const queries = {
  'New': {query: {sort: 'recent'}, title: __('members.magazine.titles.new')},
  'Popular': {query: {sort: 'popular'}, title: __('members.magazine.titles.popular')},
  'Local': {query: {local: 'true'}, title: __('members.magazine.titles.local')},
  'Favourite': {query: {favourite: 'true'}, title: __('members.magazine.titles.favourites')}
};

export function normalizeMagazineQuery(query) {
  let normalizedQuery = query;

  if(Object.keys(query).length == 0) {
    normalizedQuery = queries['New'].query;
  }

  return normalizedQuery;
}

export default queries;



/** WEBPACK FOOTER **
 ** ./src/members/__shared__/magazineQueries.js
 **/